var SelectPure = function () {
    "use strict";
    const e = {value: "data-value", disabled: "data-disabled", class: "class", type: "type"};

    class t {
        constructor(e, t = {}, s = {}) {
            return this._node = e instanceof HTMLElement ? e : document.createElement(e), this._config = {i18n: s}, this._setAttributes(t), t.textContent && this._setTextContent(t.textContent), this
        }

        get() {
            return this._node
        }

        append(e) {
            return this._node.appendChild(e), this
        }

        addClass(e) {
            return this._node.classList.add(e), this
        }

        removeClass(e) {
            return this._node.classList.remove(e), this
        }

        toggleClass(e) {
            return this._node.classList.toggle(e), this
        }

        addEventListener(e, t) {
            return this._node.addEventListener(e, t), this
        }

        removeEventListener(e, t) {
            return this._node.removeEventListener(e, t), this
        }

        setText(e) {
            return this._setTextContent(e), this
        }

        getHeight() {
            return window.getComputedStyle(this._node).height
        }

        setTop(e) {
            return this._node.style.top = `${e}px`, this
        }

        focus() {
            return this._node.focus(), this
        }

        _setTextContent(e) {
            this._node.textContent = e
        }

        _setAttributes(t) {
            for (const s in t) e[s] && t[s] && this._setAttribute(e[s], t[s])
        }

        _setAttribute(e, t) {
            this._node.setAttribute(e, t)
        }
    }

    var s = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
            var s = arguments[t];
            for (var i in s) Object.prototype.hasOwnProperty.call(s, i) && (e[i] = s[i])
        }
        return e
    };
    const i = {select: "select-pure__select", dropdownShown: "select-pure__select--opened", multiselect: "select-pure__select--multiple", label: "select-pure__label", placeholder: "select-pure__placeholder", dropdown: "select-pure__options", option: "select-pure__option", autocompleteInput: "select-pure__autocomplete", selectedLabel: "select-pure__selected-label", selectedOption: "select-pure__option--selected", placeholderHidden: "select-pure__placeholder--hidden", optionHidden: "select-pure__option--hidden"};
    return class {
        constructor(e, i) {
            this._config = s({}, i), this._state = {opened: !1}, this._icons = [], this._boundHandleClick = this._handleClick.bind(this), this._boundUnselectOption = this._unselectOption.bind(this), this._boundSortOptions = this._sortOptions.bind(this), this._body = new t(document.body), this._create(e), this._config.value && this._setValue()
        }

        value() {
            return this._config.value
        }

        _create(e) {
            const s = "string" == typeof e ? document.querySelector(e) : e;
            this._parent = new t(s), this._select = new t("div", {class: i.select}), this._label = new t("span", {class: i.label}), this._optionsWrapper = new t("div", {class: i.dropdown}), this._config.multiple && this._select.addClass(i.multiselect), this._options = this._generateOptions(), this._select.addEventListener("click", this._boundHandleClick), this._select.append(this._label.get()), this._select.append(this._optionsWrapper.get()), this._parent.append(this._select.get()), this._placeholder = new t("span", {class: i.placeholder, textContent: this._config.placeholder}), this._select.append(this._placeholder.get())
        }

        _generateOptions() {
            return this._config.autocomplete && (this._autocomplete = new t("input", {class: i.autocompleteInput, type: "text"}), this._autocomplete.addEventListener("input", this._boundSortOptions), this._optionsWrapper.append(this._autocomplete.get())), this._config.options.map(e => {
                const s = new t("div", {class: i.option, value: e.value, textContent: e.label, disabled: e.disabled});
                return this._optionsWrapper.append(s.get()), s
            })
        }

        _handleClick(e) {
            if (e.stopPropagation(), e.target.className !== i.autocompleteInput) {
                if (this._state.opened) {
                    const t = this._options.find(t => t.get() === e.target);
                    return t && this._setValue(t.get().getAttribute("data-value"), !0), this._select.removeClass(i.dropdownShown), this._body.removeEventListener("click", this._boundHandleClick), this._select.addEventListener("click", this._boundHandleClick), void (this._state.opened = !1)
                }
                e.target.className !== this._config.icon && (this._select.addClass(i.dropdownShown), this._body.addEventListener("click", this._boundHandleClick), this._select.removeEventListener("click", this._boundHandleClick), this._state.opened = !0, this._autocomplete && this._autocomplete.focus())
            }
        }

        _setValue(e, t, s) {
            if (e && !s && (this._config.value = this._config.multiple ? [...this._config.value || [], e] : e), e && s && (this._config.value = e), this._options.forEach(e => {
                e.removeClass(i.selectedOption)
            }), this._placeholder.removeClass(i.placeholderHidden), this._config.multiple) {
                const e = this._config.value.map(e => {
                    const t = this._config.options.find(t => t.value === e);
                    return this._options.find(e => e.get().getAttribute("data-value") === t.value.toString()).addClass(i.selectedOption), t
                });
                return e.length && this._placeholder.addClass(i.placeholderHidden), void this._selectOptions(e, t)
            }
            const n = this._config.value ? this._config.options.find(e => e.value.toString() === this._config.value) : this._config.options[0];
            this._options.find(e => e.get().getAttribute("data-value") === n.value.toString()).addClass(i.selectedOption), this._placeholder.addClass(i.placeholderHidden), this._selectOption(n, t)
        }

        _selectOption(e, t) {
            this._selectedOption = e, this._label.setText(e.label), this._config.onChange && t && this._config.onChange(e.value)
        }

        _selectOptions(e, s) {
            this._label.setText(""), this._icons = e.map(e => {
                const s = new t("span", {class: i.selectedLabel, textContent: e.label}), n = new t(this._config.inlineIcon ? this._config.inlineIcon.cloneNode(!0) : "i", {class: this._config.icon, value: e.value});
                return n.addEventListener("click", this._boundUnselectOption), s.append(n.get()), this._label.append(s.get()), n.get()
            }), s && this._optionsWrapper.setTop(Number(this._select.getHeight().split("px")[0]) + 5), this._config.onChange && s && this._config.onChange(this._config.value)
        }

        _unselectOption(e) {
            const t = [...this._config.value], s = t.indexOf(e.target.getAttribute("data-value"));
            -1 !== s && t.splice(s, 1), this._setValue(t, !0, !0)
        }

        _sortOptions(e) {
            this._options.forEach(t => {
                t.get().textContent.toLowerCase().startsWith(e.target.value.toLowerCase()) ? t.removeClass(i.optionHidden) : t.addClass(i.optionHidden)
            })
        }
    }
}();

const minimum_price = document.querySelector('select[name="minimum_price"]');
const maximum_price = document.querySelector('select[name="maximum_price"]');

if (minimum_price !== null && maximum_price !== null) {
    minimum_price.setAttribute('data-selected', minimum_price.value);
    minimum_price.addEventListener('change', function (event) {
        if (parseInt(event.target.value) < parseInt(maximum_price.value) || maximum_price.value == '' || maximum_price.value == 0) {
            minimum_price.setAttribute('data-selected', minimum_price.value);
        }
        minimum_price.value = minimum_price.getAttribute('data-selected');
    });

    maximum_price.setAttribute('data-selected', maximum_price.value);
    maximum_price.addEventListener('change', function (event) {
        if (parseInt(event.target.value) > parseInt(minimum_price.value) || minimum_price.value == '' || minimum_price.value == 0) {
            maximum_price.setAttribute('data-selected', maximum_price.value);
        }
        maximum_price.value = maximum_price.getAttribute('data-selected');
    });
}

var pt = document.querySelectorAll('input[name="payment_type"]');
if (pt) {
    pt.forEach(function (v) {
        v.addEventListener('change', function () {
            var minPrice = document.querySelector('select[name="minimum_price"]');
            var maxPrice = document.querySelector('select[name="maximum_price"]');

            minPrice.innerHTML = '';
            maxPrice.innerHTML = '';

            if (this.value == 1) {
                minPrice.innerHTML = document.querySelector('#purchase-template-min').innerHTML;
                maxPrice.innerHTML = document.querySelector('#purchase-template-max').innerHTML;
            } else {
                minPrice.innerHTML = document.querySelector('#rental-template-min').innerHTML;
                maxPrice.innerHTML = document.querySelector('#rental-template-max').innerHTML;
            }

        });
    });
}

var spt = document.querySelector('select[name="payment_type"]');
if (spt) {
    spt.addEventListener('change', function (v) {
        var minPrice = document.querySelector('select[name="minimum_price"]');
        var maxPrice = document.querySelector('select[name="maximum_price"]');

        minPrice.innerHTML = '';
        maxPrice.innerHTML = '';

        if (this.value == 1) {
            minPrice.innerHTML = document.querySelector('#purchase-template-min').innerHTML;
            maxPrice.innerHTML = document.querySelector('#purchase-template-max').innerHTML;
        } else {
            minPrice.innerHTML = document.querySelector('#rental-template-min').innerHTML;
            maxPrice.innerHTML = document.querySelector('#rental-template-max').innerHTML;
        }
    });
}

document.querySelectorAll('#place-form button[type="button"]').forEach(function (value) {
    value.addEventListener('click', nextStep);
});

var btn = document.querySelector('#place-form button[type="submit"]');

if (document.querySelector('#locations')) {
    var locations = document.querySelector('#locations').dataset.locations.split(';');
    var options = [];

    locations.forEach(function (value) {
        options.push({
            label: value,
            value: value
        });
    });
    var cities = ["Brielle"];

    var multi = new SelectPure(".multi-select", {
        options: options,
        value: ["Brielle"],
        multiple: true,
        icon: "fa fa-times",
        onChange: value => {
            cities = value;
        },
    });

    if (btn) {
        btn.addEventListener('click', function (event) {
            event.preventDefault();

            const configuration = {
                method: 'POST',
                body: JSON.stringify({
                    name: document.querySelector('#name').value,
                    address: document.querySelector('#address').value,
                    postal_code: document.querySelector('#postal-code').value,
                    city: document.querySelector('#city').value,
                    phone_number: document.querySelector('#phone').value,
                    email: document.querySelector('#email').value,
                    location: cities.join(', '),
                    property_type: document.querySelector('#type').value,
                    payment_type: document.querySelector('input[name="payment_type"]:checked').value,
                    rooms: document.querySelector('#rooms').value,
                    surface: document.querySelector('#surface').value,
                    minimum_price: document.querySelector('#minimum-price').value,
                    maximum_price: document.querySelector('#maximum-price').value,
                    construction_period: document.querySelector('#construction-period').value,
                    description: document.querySelector('#additional-information').value,
                    broker: document.querySelector('#broker').checked,
                    valuation: document.querySelector('#valuation').checked,
                    meeting: document.querySelector('#meeting').checked,
                }),
            };

            fetch('/zoekopdrachten/place', configuration).then(function (response) {
                const lastStep = document.querySelector('.step-container:last-of-type');

                lastStep.style.animationName = 'fill-green';
                lastStep.classList.add('completed');

                document.querySelector('#step-text-3').style.animationName = 'change-color-green';
                document.querySelector('.step[data-step="3"]').style.animationName = 'hide';
                document.querySelector('.end').style.animationName = 'slide-left-end';
            });
        });
    }
}

function nextStep(event) {
    if (triggerFormValidation(event) === false) {
        return;
    }

    triggerStepAnimation(event);
    triggerNextStep(event);
}

/**
 * Trigger the form validation.
 *
 * @param event
 * @returns {boolean}
 */
function triggerFormValidation(event) {
    const inputs = event.target.parentElement.querySelectorAll('input, select, textarea');
    var validationPassed = true;

    if (event.target.parentElement.dataset.step == 2) {
        if (!document.querySelector('#avg-check').checked) {
            document.querySelector('#avg-check').parentElement.style.color = 'red';
            validationPassed = false;
        }
    }

    inputs.forEach(function (value) {
        if (!value.checkValidity() && value.id !== 'avg-check') {
            value.reportValidity();
            validationPassed = false;
        }
    });

    return validationPassed;
}

/**
 * Trigger the "steps" animation.
 *
 * @param event
 * @return void
 */
function triggerStepAnimation(event) {
    const currentStep = event.target.closest('.step').getAttribute('data-step');
    const currentStepText = document.querySelector('#step-text-' + currentStep);
    const currentStepContainer = document.querySelector('#step-container-' + currentStep);
    const currentProgressContainer = document.querySelectorAll('#progress-container-' + currentStep + ' > div');

    const nextStep = parseInt(event.target.closest('.step').getAttribute('data-step')) + 1;
    const nextStepText = document.querySelector('#step-text-' + nextStep);
    const nextStepContainer = document.querySelector('#step-container-' + nextStep);

    currentStepText.style.animationName = 'change-color-green';
    currentStepContainer.style.animationName = 'fill-green';
    currentStepContainer.style.animationDelay = '0s';
    currentStepContainer.classList.add('completed');

    currentProgressContainer.forEach(function (value) {
        value.style.animationName = 'fill-green';
    });

    nextStepText.style.animationName = 'change-color-blue';
    nextStepContainer.style.animationName = 'fill-blue';
}

function triggerNextStep(event) {
    const currentStep = event.target.closest('.step').getAttribute('data-step');
    const nextStep = parseInt(event.target.closest('.step').getAttribute('data-step')) + 1;
    document.querySelector('.step[data-step="' + currentStep + '"]').style.animationName = 'hide';
    document.querySelector('.step[data-step="' + nextStep + '"]').style.animationName = 'slide-left-' + currentStep;
}
